import React from "react"
import styled from "styled-components"

const StyledEnactment = styled.div`
  p {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: end;
    gap: 0.5rem;
    line-height: 1.4;
  }
`
export default function Enactment() {
  return (
    <StyledEnactment>
      <p>
        <span>制定</span>
        <span>2004年12月</span>
      </p>
      <p>
        <span>改定</span>
        <span>
          2025年<span style={{ paddingInlineStart: "8px" }}>3</span>月
        </span>
      </p>
      <p>フランソアグループ</p>
    </StyledEnactment>
  )
}
